import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: 600 auto-generated "city x gold modifier" spun pages.
// The real, hand-built city pages live at /gold-rate-{city} and
// /city/{country}/{city} and are unaffected.
export const Route = createFileRoute("/gold-rate/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
